import axios from 'axios'

export default class TipoCooperativa {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoUnimedComFederacao`
    this.tokenBearer = tokenBearer
  }

  getTipoCooperativa () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoCooperativa = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoCooperativa = await axios(optionsTipoCooperativa)
        resolve(responseTipoCooperativa)
      } catch (err) {
        reject(err)
      }
    })
  }
}
